customElements.get('product-form') ||
  customElements.define(
    'product-form',
    class extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;
        this.isMainAdded = false;
        this.isReversible = Boolean(this.dataset.updateCart == 'first');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        document.getElementById('main-product-tab')?.addEventListener('click', this.goToConfiguratorHandler.bind(this));
        document.getElementById('addon-back')?.addEventListener('click', this.goToConfiguratorHandler.bind(this));
        document.getElementById('addons-tab')?.addEventListener('click', this.goToAddOnsHandler.bind(this));
        document.getElementById('configurator-next')?.addEventListener('click', this.goToAddOnsHandler.bind(this));
        document.getElementById('fabric-cover-back')?.addEventListener('click', this.goToAddOnsHandler.bind(this));
        document.getElementById('addon-next')?.addEventListener('click', this.goToFabricCoversHandler.bind(this));
        document
          .getElementById('fabric-covers-tab')
          ?.addEventListener('click', this.goToFabricCoversHandler.bind(this));
        document.querySelectorAll('.addon-product-wrapper').forEach((item) => {
          item.addEventListener('click', (event) => {
            handleAddonClick(event, item);
          });
        });
        document.querySelectorAll('.fabric-cover-product-wrapper').forEach((item) => {
          item.addEventListener('click', (event) => {
            handleAddonClick(event, item);
          });
        });
        this.initHoverSamples();
      }

      addClassToElements(elementLocators, className) {
        elementLocators.forEach((loc) => {
          document.querySelectorAll(loc).forEach((item) => {
            item.classList.add(className);
          });
        });
      }

      removeClassFromElements(elementLocators, className) {
        elementLocators.forEach((loc) => {
          document.querySelectorAll(loc).forEach((item) => {
            item.classList.remove(className);
          });
        });
      }

      addMainToCart() {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const mainFormData = new FormData(this.form);
        mainFormData.append('sections_url', window.location.pathname);
        mainFormData.append('quantity', 1);
        config.body = mainFormData;
        const mainItemData = {};
        for (const [key, value] of mainFormData.entries()) {
          // Handle multiple values for the same input name (e.g., checkboxes)
          if (mainItemData.hasOwnProperty(key)) {
            if (Array.isArray(mainItemData[key])) {
              mainItemData[key].push(value);
            } else {
              mainItemData[key] = [mainItemData[key], value];
            }
          } else {
            mainItemData[key] = value;
          }
        }

        // POST request for main product
        return fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
            } else {
              this.isMainAdded = true;
            }
          })
          .catch((error) => {
            console.error('Error adding to cart:', error);
          });
      }

      reverseAddMainToCart() {
        return fetch(`${routes.cart_change_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            quantity: 0,
            id: this.form.querySelector('[name="id"]').value,
          }),
        })
          .then((response) => {
            if (response.ok) this.isMainAdded = false;
          })
          .catch((error) => {
            console.error('Error reversing add to cart:', error);
          });
      }

      addAddOnsToCart(submitButton) {
        let addOnsFormData = { items: [] };
        const addonsInfo = document.querySelectorAll('.product-wrapper');
        for (const element of addonsInfo) {
          const addonQuantityElement = element.querySelector('.quantity__input'),
            addonVariantElement = element.getElementsByClassName('selected-value')[0],
            addonShippingElement = element.getElementsByClassName('addon-availability-text')[0];
          if (addonQuantityElement && addonVariantElement) {
            const addonQuantity = addonQuantityElement.value,
              addonVariantId = addonVariantElement.dataset.selectedVariantId,
              addonVariantShippingText = addonShippingElement.textContent || '';
            if (addonShippingElement.dataset.isPreorder === 'true') {
              addonQuantity > 0 &&
                addonVariantId &&
                addOnsFormData.items.push({
                  id: addonVariantId,
                  quantity: addonQuantity,
                  properties: { Type: addonVariantShippingText },
                });
            } else {
              addonQuantity > 0 &&
                addonVariantId &&
                addOnsFormData.items.push({
                  id: addonVariantId,
                  quantity: addonQuantity,
                });
            }
          }
        }

        // POST request for add-on products
        return (
          addOnsFormData.items.length > 0
            ? fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(addOnsFormData),
              })
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    this.handleErrorMessage(response.description);
                  } else {
                    window.location.assign('/cart');
                  }
                })
                .catch((error) => {
                  console.error('Error addin addons to cart:', error);
                })
                .finally(() => {
                  (submitButton.setAttribute('aria-disabled', false),
                    submitButton.classList.remove('loading'),
                    this.querySelector('.loading-overlay__spinner').classList.add('hidden'),
                    this.querySelector('.back-addon-text')?.classList.remove('hidden'),
                    (document.body.style.cursor = ''));
                })
            : window.location.assign('/cart'),
          submitButton.setAttribute('aria-disabled', false),
          submitButton.classList.remove('loading'),
          this.querySelector('.loading-overlay__spinner').classList.add('hidden'),
          this.querySelector('.back-addon-text')?.classList.remove('hidden'),
          (document.body.style.cursor = '')
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains('loading')) return;

        this.handleErrorMessage();

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        this.querySelector('.back-addon-text')?.classList.add('hidden');
        document.body.style.cursor = 'not-allowed';

        if (this.isReversible) {
          this.addAddOnsToCart(submitButton);
        } else {
          this.addMainToCart().then(() => this.addAddOnsToCart(submitButton));
        }
      }

      goToConfiguratorHandler(evt) {
        evt.preventDefault();
        this.removeClassFromElements(['.configurator-options-wrapper'], 'overflow-hidden');
        this.removeClassFromElements(['#addons-tab', '#fabric-covers-tab'], 'active');
        this.addClassToElements(['#main-product-tab'], 'active');
        this.addClassToElements(
          [
            '.configurator-addon-wrapper',
            '.addon_buttons',
            '.configurator-fabric-cover-wrapper',
            '.fabric-cover_buttons',
          ],
          'hidden',
        );
        this.removeClassFromElements(['.configurator-buttons'], 'hidden');
        if (this.isReversible) {
          this.reverseAddMainToCart();
        }
        document.querySelector('.configurator-options-wrapper').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      goToAddOnsHandler(evt) {
        evt.preventDefault();
        this.addClassToElements(['.configurator-options-wrapper'], 'overflow-hidden');
        this.removeClassFromElements(['#main-product-tab', '#fabric-covers-tab'], 'active');
        this.addClassToElements(['#addons-tab'], 'active');
        this.addClassToElements(
          ['.configurator-buttons', '.fabric-cover_buttons', '.configurator-fabric-cover-wrapper'],
          'hidden',
        );
        this.removeClassFromElements(['.configurator-addon-wrapper', '.addon_buttons'], 'hidden');
        document.querySelector('.configurator-options-wrapper').scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Update styles for all addon product wrappers
        document.querySelectorAll('.addon-product-wrapper').forEach((wrapper) => {
          this.updateStyles(wrapper);
        });
        if (this.isReversible && !this.isMainAdded) this.addMainToCart();
      }

      goToFabricCoversHandler(evt) {
        evt.preventDefault();
        this.addClassToElements(['.configurator-options-wrapper'], 'overflow-hidden');
        this.removeClassFromElements(['#main-product-tab', '#addons-tab'], 'active');
        this.addClassToElements(['#fabric-covers-tab'], 'active');
        this.addClassToElements(['.configurator-buttons', '.addon_buttons', '.configurator-addon-wrapper'], 'hidden');
        this.removeClassFromElements(['.configurator-fabric-cover-wrapper', '.fabric-cover_buttons'], 'hidden');
        document.querySelector('.configurator-options-wrapper').scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Update styles for all fabric cover product wrappers
        document.querySelectorAll('.fabric-cover-product-wrapper').forEach((wrapper) => {
          this.updateStyles(wrapper);
        });
        if (this.isReversible && !this.isMainAdded) this.addMainToCart();
      }

      handleTabClick(event) {
        // This function is now only used for desktop functionality
        // Mobile doesn't use tabs anymore
        const clickedTab = event.currentTarget;
        // Handle desktop tab click
        this.goToTab(clickedTab);
      }

      goToNextStep() {
        const activeTab = document.querySelector('.status-tabs.mobile .tab.active'),
          nextTab = activeTab ? activeTab.nextElementSibling : null;
        nextTab && this.goToTab(nextTab);
      }

      showBackButton() {
        const backButton = document.getElementById('configurator-back');
        backButton && backButton.classList.contains('hidden') && backButton.classList.remove('hidden');
      }

      hideBackButton() {
        const backButton = document.getElementById('configurator-back');
        backButton && !backButton.classList.contains('hidden') && backButton.classList.add('hidden');
      }

      updatePriceBasedOnAddOns() {
        let priceContainerElement = document.querySelector('.configurator-bottom-wrapper .price__container');
        if (!priceContainerElement) return;
        let totalAddOnPrice = 0,
          totalAddOnCompare = 0;
        (document.querySelectorAll('.addon-product-wrapper.active').forEach((item) => {
          const addonQuantity = parseInt(item.querySelector('.quantity__input').value),
            addonVariantPrice = parseFloat(item.querySelector('.price__container').dataset.price);
          let addonVariantCompare = parseFloat(item.querySelector('.price__container').dataset.comparedAt);
          (isNaN(addonVariantCompare) && (addonVariantCompare = addonVariantPrice),
            (totalAddOnPrice += addonVariantPrice * addonQuantity),
            (totalAddOnCompare += addonVariantCompare * addonQuantity));
        }),
          (priceContainerElement.dataset.totalPrice = totalAddOnPrice),
          (priceContainerElement.dataset.totalCompare = totalAddOnCompare));
        const basePrice = parseFloat(priceContainerElement.dataset.price),
          baseComparePrice = parseFloat(priceContainerElement.dataset.comparedAt),
          finalSalePrice = basePrice + totalAddOnPrice,
          finalComparePrice = baseComparePrice + totalAddOnCompare;
        function formatPrice(price) {
          let formattedPrice = Shopify.formatMoney(price, '${{amount}}');
          return (currencyCodeEnabled && (formattedPrice += ' ' + Shopify.currency.active), formattedPrice);
        }
        let salePriceElement = priceContainerElement.querySelector('.price__sale .price-item--sale');
        salePriceElement && (salePriceElement.innerHTML = formatPrice(finalSalePrice));
        let saleCompareElement = priceContainerElement.querySelector('.price__sale .price-item--compare');
        saleCompareElement && (saleCompareElement.innerHTML = formatPrice(finalComparePrice));
        let regularPriceElement = priceContainerElement.querySelector('.price__regular .price-item--regular');
        regularPriceElement && (regularPriceElement.innerHTML = formatPrice(finalSalePrice));
        syncPromoDisplays(finalSalePrice, finalComparePrice);
      }

      hideSamples() {
        const samples = document.querySelectorAll(this.sampleSelectors);
        samples.forEach((sampleWrapper) => {
          const sampleColors = sampleWrapper.querySelectorAll('.color__wrapper');
          sampleColors.forEach((sample) => {
            sample.classList.add('hidden');
          });
        });
      }

      showSamples(identifier, selectedElement = null) {
        this.hideSamples();
        if (identifier == undefined) return;
        const productWrapper = selectedElement?.closest('.addon-product-wrapper');
        const overrideEnabled = productWrapper?.dataset.variantImagesOverride === '1';
        const isVariant = selectedElement?.dataset.variant && overrideEnabled;
        const isMobile = this.isMobile();
        const mobileOrDesktopClass = isMobile ? '.mobile' : '.desktop';
        const fieldset = selectedElement.closest('fieldset');
        const containerWrapper = isMobile ? fieldset : document;

        const variantSamples = productWrapper
          ?.querySelector('.variant-samples' + mobileOrDesktopClass)
          ?.querySelectorAll('.color__wrapper');
        const fabricSamples = containerWrapper.querySelectorAll(
          '.fabric-samples' + mobileOrDesktopClass + ' .color__wrapper',
        );
        const cupholderSamples = containerWrapper.querySelectorAll(
          '.cupholder-samples' + mobileOrDesktopClass + ' .color__wrapper',
        );

        // Only update styles for desktop view
        if (!isMobile) {
          this.updateStyles(productWrapper);
        }

        const samples = isVariant ? variantSamples : [...fabricSamples, ...cupholderSamples];
        samples.forEach((sample) => {
          const color = String(sample.dataset.color).replace('-4-0', '');
          if (sample.dataset.variant === identifier || (!isVariant && color === identifier)) {
            if (sample.classList.contains('hidden') && sample.classList.contains('magnify')) {
              // Only show modal when variant is already selected (Mobile)
              sample.parentNode.classList.remove('hidden');
              sample.classList.remove('hidden');
            } else if (sample.classList.contains('hidden') && isMobile) {
              // Add a class when ready to show (Mobile)
              sample.classList.add('magnify');
            } else {
              // Show popup on hover (Desktop)
              sample.classList.remove('hidden');
            }
          } else {
            sample.classList.add('hidden');
            sample.classList.remove('magnify');
          }
        });
      }

      updateStyles(productWrapper) {
        if (this.isMobile()) return;

        const infoWrapper = document.querySelector('.product__info-wrapper');
        const variantSamples = productWrapper?.querySelector('.variant-samples.desktop');
        const variantSample = productWrapper?.querySelector('.variant-samples.desktop .color__wrapper');
        const productMediaWrapper = document.querySelector('.product__media-wrapper');
        if (!variantSamples | !infoWrapper | !variantSample | !productMediaWrapper) return;

        const variantSamplesRect = variantSamples.getBoundingClientRect();
        const productMediaRect = productMediaWrapper.getBoundingClientRect();
        const infoWrapperRect = infoWrapper.getBoundingClientRect();

        const clone = variantSample.cloneNode(true);
        clone.classList.remove('hidden');
        clone.style.visibility = 'hidden';
        const imageElement = clone.querySelector('.color__image');
        if (imageElement) {
          imageElement.innerHTML = '';
        }
        variantSample.insertAdjacentElement('afterend', clone);
        const cloneWidth = clone.offsetWidth;
        clone.remove();

        const yPos = -productMediaRect.bottom + variantSamplesRect.bottom;
        const xPos = cloneWidth + (productWrapper?.getBoundingClientRect().left - infoWrapperRect.left);

        const style = document.querySelector('#custom-css');
        style.textContent = `
            .variant-samples.desktop {
              position: relative !important;
              bottom: 30px;
              right: 0;
              z-index: 50;
              width: 100%;
            }

            .variant-samples.desktop .color__wrapper {
              position: absolute !important;
              right: ${xPos}px;
              bottom: ${yPos}px;
              width: 313px;
            }

            /* Preserve mobile positioning */
            .variant-samples.mobile {
              position: fixed !important;
              bottom: 0;
              left: 0;
              width: 100%;
              z-index: 50;
            }
        `;
      }

      isMobile() {
        // Check if the screen width is below 990px (mobile)
        return window.innerWidth < 990;
      }

      async handleSampleDisplay(label) {
        await this.updateVariantSamplesPosition(label);
        const hoveredVariant = label.dataset.variant;
        const hoveredColor = label.dataset.color ? label.dataset.color : label.dataset.hoverColor;

        // Desktop behavior
        if (hoveredVariant) {
          this.showSamples(hoveredVariant, label);
        } else {
          this.showSamples(hoveredColor, label);
        }
      }

      updateVariantSamplesPosition(selectedElement) {
        if (!this.isMobile()) return;
        return new Promise((resolve) => {
          setTimeout(() => {
            const fieldset = selectedElement.closest('.configurator-addon-wrapper fieldset');
            const variantSamples = fieldset?.querySelector('.variant-samples.mobile');
            if (variantSamples) {
              variantSamples.style.setProperty('bottom', fieldset.offsetHeight + 'px', 'important');
            }
            resolve();
          }, 100);
        });
      }

      updateFormLabel(fieldset) {
        const formLabel = fieldset?.querySelector('.form__label .selected-value');
        const selectedInput = fieldset?.querySelector('input:checked');
        if (!formLabel || !selectedInput) return;

        const selectedLabel = selectedInput.nextElementSibling;
        const productWrapper = selectedLabel?.closest('.addon-product-wrapper');
        const overrideEnabled = productWrapper?.dataset.variantImagesOverride === '1';

        if (overrideEnabled) {
          formLabel.textContent = selectedLabel.dataset.title || '';
        } else {
          const colorWrapper = document.querySelector(
            `.color__wrapper[data-color="${selectedLabel.dataset.hoverColor}"]`,
          );
          const colorName = colorWrapper?.querySelector('.color__name')?.textContent?.trim();
          formLabel.textContent = colorName || selectedLabel.dataset.title || '';
        }
      }

      initHoverHandlers(wrapperSelector, sampleSelectors) {
        this.sampleSelectors = sampleSelectors;
        const wrappers = document.querySelectorAll(wrapperSelector);
        if (wrappers.length === 0) return;

        const samples = document.querySelectorAll(sampleSelectors);
        if (samples.length === 0) return;

        // Preselect first variant and update all form labels initially
        wrappers.forEach((wrapper) => {
          const fieldset = wrapper.closest('fieldset');
          if (fieldset) {
            // If no variant is selected, select the first one
            const selectedInput = fieldset.querySelector('input:checked');
            if (!selectedInput) {
              const firstInput = fieldset.querySelector('input[type="radio"]');
              if (firstInput) {
                firstInput.checked = true;
                firstInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
            this.updateFormLabel(fieldset);
          }
        });

        wrappers.forEach((wrapper) => {
          const labels = wrapper.querySelectorAll('label');
          if (labels.length === 0) return;

          labels.forEach((label) => {
            if (window.innerWidth > 990) {
              label.addEventListener('mouseenter', () => {
                clearTimeout(timeoutId);
                // Update form label
                const fieldset = label.closest('fieldset');
                const formLabel = fieldset?.querySelector('.form__label .selected-value');
                if (formLabel) {
                  if (label.dataset.variant) {
                    formLabel.textContent = label.dataset.title || '';
                  } else {
                    const colorWrapper = document.querySelector(
                      `.color__wrapper[data-color="${label.dataset.hoverColor}"]`,
                    );
                    const colorName = colorWrapper?.querySelector('.color__name')?.textContent?.trim();
                    formLabel.textContent = colorName || label.dataset.title || '';
                  }
                }
                this.handleSampleDisplay(label);
              });

              label.addEventListener('mouseleave', () => {
                timeoutId = setTimeout(() => {
                  // Restore selected value
                  const fieldset = label.closest('fieldset');
                  this.updateFormLabel(fieldset);
                  this.hideSamples();
                }, 100);
              });
            } else {
              label.addEventListener('click', () => {
                this.handleSampleDisplay(label);
              });
            }
          });
        });

        samples.forEach((sampleWrapper) => {
          const sampleColors = sampleWrapper.querySelectorAll('.color__wrapper');
          sampleColors.forEach((sample) => {
            sample.querySelector('.color__close').addEventListener('click', (event) => {
              event.preventDefault();
              sample.parentNode.classList.add('hidden');
              sample.classList.add('hidden');
              event.stopPropagation();
            });
            // Apply magnify class to selected input so that clicking it again immediately shows the sample modal
            const color = String(sample.dataset.color).replace('-4-0', '');
            // Not all samples have adjacent fieldsets (e.g. configurator-all-hover-samples)
            const fieldset = sample.closest('fieldset');
            const parentElement = fieldset || document;
            const inputLabel = parentElement.querySelector(`label[data-color="${color}"]`);
            if (inputLabel?.previousElementSibling.checked) {
              sample.classList.add('magnify');
            }
          });
        });

        let timeoutId;
      }

      initHoverSamples() {
        // Add event listeners for hover
        this.querySelectorAll('.option-addon-swatch-label').forEach((label) => {
          label.addEventListener('mouseover', () => {
            const hoveredColor = label.dataset.hoverColor;
            const hoveredVariant = label.dataset.variant;
            if (hoveredVariant) {
              this.showSamples(hoveredVariant, label);
            } else {
              this.showSamples(hoveredColor, label);
            }
          });

          label.addEventListener('mouseout', () => {
            const fieldset = label.closest('fieldset');
            const formLabel = fieldset?.querySelector('.form__label .selected-value');
            const selectedInput = fieldset?.querySelector('input:checked');
            if (formLabel && selectedInput) {
              const selectedLabel = selectedInput.nextElementSibling;
              formLabel.textContent = selectedLabel.dataset.title || '';
            }
            this.hideSamples();
          });
        });

        // Setup hover samples positioning
        const infoWrapper = document.querySelector('.product__info-wrapper');
        if (!infoWrapper) return;

        const handleScroll = () => {
          const samples = document.querySelector('.variant-samples');
          if (!samples) return;

          const infoRect = infoWrapper.getBoundingClientRect();
          const viewportHeight = window.innerHeight;

          if (infoRect.bottom <= viewportHeight) {
            samples.style.position = 'absolute';
            samples.style.top = 'auto';
          } else {
            samples.style.position = 'fixed';
            samples.style.top = 'auto';
          }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        this.initHoverHandlers(
          '.product-form__input.color .product-form__input-wrapper,\
            .product-form__input.cupholders .product-form__input-wrapper,\
            .product-form__input-wrapper.cupholder-addon,\
            .product-form__input-wrapper.ottoman-addon,\
            .product-form__input-wrapper.seat-module,\
            .product-form__input-wrapper.corner-seat-module,\
            .product-form__input-wrapper.cover-4-0, \
            .product-form__input-wrapper.pillow',
          '.fabric-samples, .cupholder-samples, .variant-samples',
        );
      }

      goToTab(tab) {
        this.hideAllSamples();
        const tabs = document.querySelectorAll('.status-tabs.mobile .tab');
        (tab ? tab.previousElementSibling : null) ? this.showBackButton() : this.hideBackButton();
        const activeTab = document.querySelector('.status-tabs.mobile .tab.active'),
          clickedTab = tab;
        if (window.innerWidth < 990 && window.isConfiguratorSectional && activeTab && clickedTab) {
          const activeTabIndex = Array.from(activeTab.parentNode.children).indexOf(activeTab),
            clickedTabIndex = Array.from(clickedTab.parentNode.children).indexOf(clickedTab),
            isAddOnsTab =
              activeTab.getAttribute('id') === 'addons-tab' || activeTab.getAttribute('id') === 'addons-tab-mobile';
          clickedTabIndex < activeTabIndex && isAddOnsTab && this.handleAddOnsBack();
        }
        (tabs.forEach((tabInstance) => {
          tabInstance.classList.remove('active');
        }),
          tab.classList.add('active'),
          document.querySelectorAll('.tab-content').forEach((content) => {
            content.style.display = 'none';
          }),
          this.showContent(tab.dataset.target));
      }

      showContent(targetId) {
        const targetContent = document.getElementById(targetId);
        targetContent && (targetContent.style.display = 'block');
      }

      handleErrorMessage(errorMessage = !1) {
        ((this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')),
          (this.errorMessage =
            this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')),
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage),
          errorMessage && (this.errorMessage.textContent = errorMessage));
      }

      hideAllSamples() {
        const samples = document.querySelectorAll(
          '.fabric-samples.mobile .color__wrapper, .cupholder-samples.mobile .color__wrapper',
        );
        samples.forEach(function (sample) {
          sample.classList.add('hidden');
        });
      }
    },
  );

function handleAddonClick(event, item) {
  const addOnKey = item.dataset.addonKey;
  const addToCartButton = item.querySelector('.addon-add-to-cart');
  const quantityInput = item.querySelector('.quantity input');
  const isInitialState = initializeAddonQuantity(event, item, addToCartButton, quantityInput);
  updateVariantPrice(event, item, addOnKey, isInitialState);
  toggleItemActiveState(event, item, addOnKey, addToCartButton, quantityInput);
}
function initializeAddonQuantity(event, item, addToCartButton, quantityInput) {
  const variantRadios = item.querySelector('variant-radios');
  const quantityButtonMinus = item.querySelector('.quantity button[name="minus"]');
  if (variantRadios) {
    variantRadios.updateOptions();
    variantRadios.updateMasterId();
    variantRadios.updateSelectedValue();
    variantRadios.updateCheckoutLabel();
  }
  if (quantityInput && !quantityButtonMinus.contains(event.target) && parseInt(quantityInput.value) === 0) {
    if (addToCartButton.contains(event.target)) {
      quantityInput.value = 1;
      addToCartButton.classList.add('hidden');
      return true;
    } else {
      addToCartButton.classList.remove('hidden');
      return false;
    }
  }
  return false;
}
function updateVariantPrice(event, selectedElement, addOnKey, isInitialState) {
  const addonWrapper = selectedElement.closest(`.${addOnKey}-product-wrapper`);
  if (!addonWrapper) return;
  const variantDataElement = addonWrapper.querySelector('.variant-data'),
    variantsData = JSON.parse(variantDataElement.textContent),
    selectedOptions = [];
  addonWrapper.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
    selectedOptions.push(input.value);
  });
  const combinationKey = selectedOptions.join(' / '),
    matchingVariant = variantsData.find((variant) => variant.options.join(' / ') === combinationKey),
    priceContainer = addonWrapper.querySelector('.price__container');
  if (matchingVariant && priceContainer) {
    const price = matchingVariant.price,
      compareAtPrice = matchingVariant.compare_at_price,
      addonQuantity = parseInt(addonWrapper.querySelector('.quantity__input').value) || 0;
    (priceContainer.setAttribute('data-price', price),
      priceContainer.setAttribute('data-compared-at', compareAtPrice || 0));
    const regularPriceElement = priceContainer.querySelector('.price-item--regular'),
      salePriceElement = priceContainer.querySelector('.price-item--sale'),
      comparePriceElement = priceContainer.querySelector('.price-item--compare');
    const priceDisplay = window.innerWidth < 990 ? 'block' : 'flex';
    ((regularPriceElement.textContent = formatPrice(price)),
      compareAtPrice && compareAtPrice > price
        ? ((salePriceElement.textContent = formatPrice(price)),
          (comparePriceElement.textContent = formatPrice(compareAtPrice)),
          (priceContainer.querySelector('.price__regular').style.display = 'none'),
          (priceContainer.querySelector('.price__sale').style.display = priceDisplay))
        : ((priceContainer.querySelector('.price__regular').style.display = priceDisplay),
          (priceContainer.querySelector('.price__sale').style.display = 'none')));
    const priceContainerElement = document.querySelector('.configurator-price .price__container');
    (updateTotalPriceData(
      priceContainerElement,
      price,
      compareAtPrice || 0,
      addonQuantity,
      addonWrapper,
      event,
      isInitialState,
    ),
      updateDisplayedPrices(priceContainerElement));

    const isPreorder = Boolean(matchingVariant.is_preorder);
    const availabilityEl = addonWrapper.querySelector('.addon-availability-text');
    if (availabilityEl) availabilityEl.dataset.isPreorder = String(isPreorder);
    const addToCartBtn = addonWrapper.querySelector('.addon-add-to-cart');
    if (addToCartBtn) {
      const preorderLabel =
        (window.sectionSettings && window.sectionSettings.preorderButtonLabel) || 'Pre-Order';
      // Gated by window.sectionSettings.preorderButtonLabelEnabled (see sections/configurator.liquid);
      // while that is false the add-on card button stays "Add to Cart" on pre-order variants too.
      const labelPreorderButtons = Boolean(
        window.sectionSettings && window.sectionSettings.preorderButtonLabelEnabled,
      );
      addToCartBtn.textContent = isPreorder && labelPreorderButtons ? preorderLabel : 'Add to Cart';
    }
  }
}
function toggleItemActiveState(event, item, addOnKey, addToCartButton, quantityInput) {
  const quantityInputs = item.querySelector('.quantity');
  const isZeroQuantity = Number.parseInt(quantityInput.value) === 0;
  if (isZeroQuantity) {
    item.querySelector(`.${addOnKey}-price-quantity .quantity`).classList.add('hidden');
    addToCartButton.classList.remove('hidden');
  } else {
    item.querySelector(`.${addOnKey}-price-quantity .quantity`).classList.remove('hidden');
    addToCartButton.classList.add('hidden');
  }
  if (!item.classList.contains('active') && !quantityInputs.contains(event.target)) {
    item.classList.add('active');
  } else if (
    item.classList.contains('active') &&
    !addToCartButton.contains(event.target) &&
    !quantityInputs.contains(event.target)
  ) {
    if (isZeroQuantity) {
      // Hide button when going inactive and no quantity
      addToCartButton.classList.add('hidden');
    }
    item.classList.remove('active');
  } else if (!item.classList.contains('active') && quantityInputs.contains(event.target) && isZeroQuantity) {
    // Hide button when inactive and no quantity
    addToCartButton.classList.add('hidden');
  }
}
function getSelectedVariantPrices(item) {
  const selectedOptions = [];
  item.querySelectorAll('input[type="radio"]').forEach(function (input) {
    input.checked && selectedOptions.push(input.value);
  });
  const combinationKey = selectedOptions.join(' / '),
    variantDataElement = item.querySelector('.variant-data');
  if (!variantDataElement) return { addonVariantPrice: 0, addonVariantCompare: 0 };
  const matchingVariant = JSON.parse(variantDataElement.textContent).find(
      (variant) => variant.options.join(' / ') === combinationKey,
    ),
    addonVariantPrice = matchingVariant ? parseFloat(matchingVariant.price) : 0,
    addonVariantCompare = (matchingVariant && parseFloat(matchingVariant.compare_at_price)) || addonVariantPrice;
  return { addonVariantPrice, addonVariantCompare };
}
function updateTotalPriceData(
  priceContainer,
  addonVariantPrice,
  addonVariantCompare,
  addonQuantity,
  item,
  event,
  isInitialState,
) {
  const quantityButtonMinus = item.querySelector('.quantity button[name="minus"]'),
    quantityButtonPlus = item.querySelector('.quantity button[name="plus"]'),
    currentAddonTotalPrice = addonVariantPrice * addonQuantity,
    currentAddonTotalCompare = addonVariantCompare * addonQuantity,
    existingAddonPrice = parseFloat(priceContainer.dataset.totalPrice) || 0,
    existingAddonCompare = parseFloat(priceContainer.dataset.totalCompare) || 0;
  if (isInitialState) {
    // Handle initial state (first click with no quantity input yet)
    ((priceContainer.dataset.totalPrice = existingAddonPrice + currentAddonTotalPrice),
      (priceContainer.dataset.totalCompare = existingAddonCompare + currentAddonTotalCompare));
  } else if (event && (quantityButtonPlus === event.target || quantityButtonMinus === event.target)) {
    const changeAmount = quantityButtonPlus === event.target ? addonVariantPrice : -addonVariantPrice,
      compareChangeAmount = quantityButtonPlus === event.target ? addonVariantCompare : -addonVariantCompare;
    ((priceContainer.dataset.totalPrice = existingAddonPrice + changeAmount),
      (priceContainer.dataset.totalCompare = existingAddonCompare + compareChangeAmount));
  } else {
    const previousAddonPrice = parseFloat(item.getAttribute('data-previousAddonPrice')) || 0,
      previousAddonCompare = parseFloat(item.getAttribute('data-previousAddonCompare')) || 0;
    ((priceContainer.dataset.totalPrice = existingAddonPrice - previousAddonPrice + currentAddonTotalPrice),
      (priceContainer.dataset.totalCompare = existingAddonCompare - previousAddonCompare + currentAddonTotalCompare));
  }
  // Store the current price on the item itself, not on the price container
  (item.setAttribute('data-previousAddonPrice', currentAddonTotalPrice),
    item.setAttribute('data-previousAddonCompare', currentAddonTotalCompare));
}
function updateDisplayedPrices(priceContainerElement) {
  const salePriceInitial = parseFloat(priceContainerElement.dataset.price) || 0,
    regularPriceInitial = parseFloat(priceContainerElement.dataset.comparedAt) || salePriceInitial,
    updatedSalePrice = salePriceInitial + parseFloat(priceContainerElement.dataset.totalPrice || 0),
    updatedComparePrice = regularPriceInitial + parseFloat(priceContainerElement.dataset.totalCompare || 0),
    salePriceElement = document.querySelector('.configurator-bottom-wrapper .price__sale .price-item--sale'),
    saleCompareElement = document.querySelector('.configurator-bottom-wrapper .price__sale .price-item--regular'),
    regularPriceElement = document.querySelector('.configurator-bottom-wrapper .price__regular .price-item--regular'),
    comparePriceElement = document.querySelector('.configurator-bottom-wrapper .price__sale .price-item--compare');
  (salePriceElement && (salePriceElement.innerHTML = formatPrice(updatedSalePrice)),
    saleCompareElement && (saleCompareElement.innerHTML = formatPrice(updatedComparePrice)),
    regularPriceElement && (regularPriceElement.innerHTML = formatPrice(updatedSalePrice)),
    comparePriceElement && (comparePriceElement.innerHTML = formatPrice(updatedComparePrice)));
  const showSalePrice = updatedComparePrice > updatedSalePrice;
  ((document.querySelector('.configurator-bottom-wrapper .price__regular').style.display = showSalePrice
    ? 'none'
    : 'flex'),
    (document.querySelector('.configurator-bottom-wrapper .price__sale').style.display = showSalePrice
      ? 'flex'
      : 'none'));
  syncPromoDisplays(updatedSalePrice, updatedComparePrice);
}
function formatPrice(price) {
  let formattedPrice = Shopify.formatMoney(price, '${{amount}}');
  return (
    window.currencyCodeEnabled &&
      Shopify.currency &&
      Shopify.currency.active &&
      (formattedPrice += ' ' + Shopify.currency.active),
    formattedPrice
  );
}
// Every path that recomputes the configured totals (add-on changes here, variant changes
// in variant-selects.js) funnels through this so the pill and the top summary can never
// disagree with the Total. Exposed on window because variant-selects.js loads separately.
window.syncConfiguratorPromo = syncPromoDisplays;
// Reads the configured totals straight off the Total block, for callers that run after
// the data attributes have been updated but don't have the numbers to hand.
// promo-expiry.js clears data-savings-pill-deferred the moment a promo override
// reaches its end date -- in the browser, so a cached page can't strand the slot
// empty. Re-run the sync straight away so the Save $X pill appears in its place
// rather than waiting for the shopper's next configuration change.
document.addEventListener('rz:promo-expired', function () {
  if (window.syncConfiguratorPromoFromDom) window.syncConfiguratorPromoFromDom();
});
window.syncConfiguratorPromoFromDom = function () {
  const container = document.querySelector('.configurator-bottom-wrapper .price__container');
  if (!container) return;
  const basePrice = parseFloat(container.dataset.price) || 0;
  const baseCompare = parseFloat(container.dataset.comparedAt) || basePrice;
  syncPromoDisplays(
    basePrice + (parseFloat(container.dataset.totalPrice) || 0),
    baseCompare + (parseFloat(container.dataset.totalCompare) || 0),
  );
};
function syncPromoDisplays(salePrice, comparePrice) {
  syncKlarnaAmount(salePrice);
  const savings = comparePrice - salePrice;
  const onPromo = savings > 0;

  const pill = document.querySelector('.configurator-bottom-wrapper [data-savings-pill]');
  if (pill) {
    // A deferred pill is sitting behind a still-live promo override, which owns the
    // slot. Keep its text current so it is correct the instant the override lapses,
    // but leave it hidden -- showing both would put two gold pills side by side.
    const deferred = pill.hasAttribute('data-savings-pill-deferred');
    onPromo && (pill.textContent = 'Save ' + Shopify.formatMoney(savings, '${{amount_no_decimals}}'));
    pill.style.display = onPromo && !deferred ? '' : 'none';
  }

  // The top summary mirrors the configured total, so it can't disagree with the Total block.
  // Quiet anchor only -- no pill here by design.
  const header = document.querySelector('.mobile-sticky-header__price');
  if (!header) return;
  const headerRegular = header.querySelector('.price__regular .price-item--regular');
  const headerSale = header.querySelector('.price__sale .price-item--sale');
  const headerCompare = header.querySelector('.price__sale .price-item--compare');
  (headerRegular && (headerRegular.innerHTML = formatPrice(salePrice)),
    headerSale && (headerSale.innerHTML = formatPrice(salePrice)),
    headerCompare && (headerCompare.innerHTML = formatPrice(comparePrice)));
  // Toggle the class the CSS keys off, then clear the inline display rather than forcing a
  // value -- the header lays its price out inline, the Total lays it out as a flex column,
  // so each one's own stylesheet has to win.
  header.classList.toggle('price--on-sale', onPromo);
  const headerPriceRoot = header.querySelector('.price');
  if (headerPriceRoot) headerPriceRoot.classList.toggle('price--on-sale', onPromo);
  const headerRegularWrap = header.querySelector('.price__regular');
  const headerSaleWrap = header.querySelector('.price__sale');
  (headerRegularWrap && (headerRegularWrap.style.display = onPromo ? 'none' : ''),
    headerSaleWrap && (headerSaleWrap.style.display = onPromo ? '' : 'none'));
  (headerSale && (headerSale.style.display = ''), headerCompare && (headerCompare.style.display = ''));
}
// Klarna on-site messaging. The app block is seeded with the variants of the product the
// page was served as, and its own script only follows variant changes within that list.
// Add-ons never change the variant, and a seat or shape swap loads a different product
// whose variants it never had -- after which it stops following model changes too. So the
// configured total is pushed onto the placement here, from the one funnel every total
// recompute goes through (add-ons, model, colour, seat and shape swaps).
//
// Klarna's app re-derives the amount from ?variant= and its seeded list on EVERY DOM
// mutation anywhere in the body (a childList observer on document.body -- with the promo
// countdown ticking, that is about once a second), and writes it straight back. Correcting
// after the fact can't keep up with that, so the placement's own setAttribute is wrapped:
// while a configured total is known, any write of the amount lands as that total, and a
// write that would change nothing is dropped so it can't trigger a re-render. The observer
// is only a backstop for a future version of theirs that bypasses setAttribute, bounded
// per sync so it can never ping-pong.
const KLARNA_AMOUNT_ATTR = 'data-purchase-amount';
const KLARNA_MAX_CORRECTIONS = 8;
let klarnaTarget = null;
const klarnaEntries = [];

function refreshKlarna() {
  // The library may not have landed yet; it reads the attribute on its first pass anyway.
  const osm = window.Klarna && window.Klarna.OnsiteMessaging;
  if (osm && typeof osm.refresh === 'function') osm.refresh();
}

function klarnaEntry(placement) {
  let entry = klarnaEntries.find((e) => e.node === placement);
  if (entry) return entry;
  entry = { node: placement, corrections: 0 };
  klarnaEntries.push(entry);

  const nativeSetAttribute = placement.setAttribute;
  placement.setAttribute = function (name, value) {
    if (klarnaTarget && String(name).toLowerCase() === KLARNA_AMOUNT_ATTR) {
      if (this.getAttribute(KLARNA_AMOUNT_ATTR) === klarnaTarget) return;
      value = klarnaTarget;
    }
    return nativeSetAttribute.call(this, name, value);
  };

  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (!klarnaTarget || entry.corrections >= KLARNA_MAX_CORRECTIONS) return;
      if (placement.getAttribute(KLARNA_AMOUNT_ATTR) === klarnaTarget) return;
      entry.corrections++;
      placement.setAttribute(KLARNA_AMOUNT_ATTR, klarnaTarget);
    }).observe(placement, { attributes: true, attributeFilter: [KLARNA_AMOUNT_ATTR] });
  }
  return entry;
}

function syncKlarnaAmount(totalCents) {
  const placements = document.querySelectorAll('klarna-placement');
  if (!placements.length || !totalCents || totalCents <= 0) return;

  klarnaTarget = String(Math.round(totalCents));
  let changed = false;
  placements.forEach((placement) => {
    klarnaEntry(placement).corrections = 0;
    if (placement.getAttribute(KLARNA_AMOUNT_ATTR) === klarnaTarget) return;
    placement.setAttribute(KLARNA_AMOUNT_ATTR, klarnaTarget);
    changed = true;
  });
  if (changed) refreshKlarna();
}
function formatWithCurrency(amount) {
  const formattedAmount = Shopify.formatMoney(amount, '${{amount}}'),
    currencyCode = Shopify.currency.active;
  return `${formattedAmount} ${currencyCode}`;
}
//# sourceMappingURL=/s/files/1/0636/0265/5480/t/58/assets/configurator-product-form.js.map?v=1732293699